/**
 * Background — fullscreen CSS gradient layer for the homepage.
 * Positioned absolute, behind all content (z-0).
 */
export function Background() {
  return (
    <div
      aria-hidden="true"
      className="absolute inset-0 z-0 overflow-hidden"
    >
      {/* Primary radial gradient — warm deep amber/brown in top-right */}
      <div
        className="absolute inset-0"
        style={{
          background: [
            'radial-gradient(ellipse 80% 60% at 70% 10%, rgba(120, 80, 30, 0.25) 0%, transparent 60%)',
            'radial-gradient(ellipse 60% 50% at 10% 90%, rgba(80, 50, 20, 0.18) 0%, transparent 60%)',
            'linear-gradient(160deg, #0d0b09 0%, #110e0b 40%, #0d0b09 100%)',
          ].join(', '),
        }}
      />
      {/* Subtle noise texture via SVG filter */}
      <div
        className="absolute inset-0 opacity-[0.025]"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
          backgroundRepeat: 'repeat',
          backgroundSize: '200px 200px',
        }}
      />
    </div>
  );
}
